import { type Static, Type as t } from '@sinclair/typebox';

export const Role = {
  Flic: 'flic',
  Infiltre: 'infiltre',
  Clochard: 'clochard',
} as const;
export type Role = (typeof Role)[keyof typeof Role];

export const RoleSchema = t.Union(
  [t.Literal(Role.Flic), t.Literal(Role.Infiltre), t.Literal(Role.Clochard)],
  { $id: 'Role' },
);

export const PlayerStatus = {
  Alive: 'alive',
  Eliminated: 'eliminated',
} as const;
export type PlayerStatus = (typeof PlayerStatus)[keyof typeof PlayerStatus];

export const PlayerStatusSchema = t.Union(
  [t.Literal(PlayerStatus.Alive), t.Literal(PlayerStatus.Eliminated)],
  { $id: 'PlayerStatus' },
);

/** Connection liveness — orthogonal to `PlayerStatus`. Server flips, client mirrors. */
export const Presence = {
  Online: 'online',
  Reconnecting: 'reconnecting',
  Offline: 'offline',
} as const;
export type Presence = (typeof Presence)[keyof typeof Presence];

export const PresenceSchema = t.Union(
  [t.Literal(Presence.Online), t.Literal(Presence.Reconnecting), t.Literal(Presence.Offline)],
  { $id: 'Presence' },
);

/** Permissive schema — web owns valid keys; server is opaque transport. */
export const MugshotSchema = t.Record(t.String(), t.String(), { $id: 'Mugshot' });
export type Mugshot = Static<typeof MugshotSchema>;

export const PlayerSchema = t.Object(
  {
    id: t.String({ minLength: 1 }),
    name: t.String({ minLength: 1, maxLength: 32 }),
    role: t.Optional(RoleSchema),
    word: t.Optional(t.String()),
    status: PlayerStatusSchema,
    isHost: t.Boolean(),
    order: t.Integer({ minimum: 0 }),
    mugshot: t.Optional(MugshotSchema),
    /** Optional for legacy `localStorage:v2`. Missing → `online`. */
    presence: t.Optional(PresenceSchema),
    /** ms of last heartbeat/engine interaction. Optional for legacy snapshots. */
    lastSeenAt: t.Optional(t.Number()),
  },
  { $id: 'Player' },
);
export type Player = Static<typeof PlayerSchema>;
